import React from "react"
import PropTypes from "prop-types"
import LocationSettings from '../setting_components/LocationSettings'


class SignUpLocation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }
  }

  render() {
    return(
      <div>
        <LocationSettings signup={true} />
      </div>
    )
  }

}

export default SignUpLocation
